export default __webpack_public_path__ + "79371fb198a2b519fd80e00fbf6532e0.png";